$(document).ready(function () {
	var
		ua = navigator.userAgent.toLowerCase(),
		event = (ua.match(/Android/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || ua.match(/iPhone/i)) ? "touchstart" : "click",
		isMobile = ua.match(/(iphone|ipod|ipad|android)/),
		window_w = $(window).width(),
		window_h = $(window).height(),
		is_home = $('body').hasClass('ishome');

	$.blockUI.defaults.message = 'Aguarde.';

	/* $.cookieBar({
		message: LANG.cookies_txt,
		acceptText: LANG.cookies_btn,
		fixed: true,
		bottom: true,
		policyButton: true,
		policyText: LANG.cp_txt,
		policyURL: LANG.cp_url,
	}); */

	$('html').removeClass('no-js');

	if (("standalone" in window.navigator) && window.navigator.standalone) {
		$('html').addClass('ios-standalone');
	}

	if ($.browser.msie) {
		$('html').addClass('is-ie');
		$('html').addClass('ie-' + $.browser.versionNumber);
	}

	if ($.browser.msedge) {
		$('html').addClass('is-edge');
	}

	if ($.browser.iphone && $.browser.safari) {
		$('html').addClass('ios-safari');
	}

	if ($.browser.iphone && $.browser.chrome) {
		$('html').addClass('ios-chrome');
	}

	if ($.browser.android && $.browser.chrome) {
		$('html').addClass('android-chrome');
	}


	$('#scroll-down-home a').click(function () 
	{
		$('body,html').animate({ scrollTop: $(window).height() }, 800);
		return false;
	});

	$('#scroll-down-page a').click(function () 
	{
		$('body,html').animate({ scrollTop: $(".page-header-container").height() }, 800);
		return false;
	});

	/**
	 * Embed responsive
	 */
	var iframe = $('.text iframe');
	if (iframe.length) {
		iframe.wrap("<div class='embed'></div>");
	}


	$('body').on('click', '.toggle:not(.close)', function (e) 
    {
		e.preventDefault();
		blockScroll(1);
		$('.menu-mobile').addClass('show');
		$(this).addClass('close');
	});

	$('body').on('click', '.toggle.close', function (e) {
		e.preventDefault();
		if($('#menu-principal').hasClass('show')){
			$('.toggle').removeClass('back');
			$('#menu-principal').removeClass('show');
			$('.sub-menu').removeClass('show');
		}else{
			blockScroll(0);
			$('.menu-mobile').removeClass('show');
			$(this).removeClass('close');
		}
	});

	function blockScroll(block) {
		if (block == 1) {
			$('html').addClass('block-scroll');
		} else if (block == 0) {
			$('html').removeClass('block-scroll');
		}
    }
    
    $(window).on('scroll', function(){
        if(!$('header').hasClass("no-scrolled"))
        {
            if ($(this).scrollTop() > 100)
                $('header').addClass("scrolled")
            else
                $('header').removeClass("scrolled")
        }
	});
    $(window).trigger("scroll");
    
    $('.banner-slider').slick({
        dots: true,
        arrows: false,
        useTransform:false,
		slidesToShow: 1,
		infinite:false,
    });

	$('.whatsnew-slider').on('init', function(event, slick)
	{
		if($(window).width()>991)
		{
			var l = parseInt($(".whatsnew-slider .slick-track").css("left"));
			$(".whatsnew-pagination").css("left",(l+60) + "px");
		}
		
	});

	$('.whatsnew-slider').slick({
        dots: false,
        arrows: false,
        useTransform:false,
		slidesToShow: 5,
		draggable:false,
		infinite:false,
		centerMode: true,
		responsive: [
			{
				breakpoint: 1400,
				settings: {
				  slidesToShow: 4,
				}
			  },
			{
			  breakpoint: 992,
			  settings: {
				slidesToShow: 3,
				infinite:false,
				centerMode: false
			  }
			},
			{
			  breakpoint: 700,
			  settings: {
				slidesToShow: 2,
				infinite:false,
				centerMode: false
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
				slidesToShow: 1,
				infinite:false,
				centerMode: false
			  }
			}
		]
    });

	// On before slide change
	$('.whatsnew-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){

		if($(window).width()>991)
		{
			if(currentSlide > nextSlide)
			{
				var el = $($(slick.$slides.get(currentSlide))).prev();
				el.removeClass("opaque");
			}
			else
			{
				var el = $($(slick.$slides.get(currentSlide)));
				el.addClass("opaque");
			}
		}
	});

	$(".whatsnew-overlay-content a.prev").click(function(e)
	{
		e.preventDefault();
		$('.whatsnew-slider').slick('slickPrev');
	});

	$(".whatsnew-overlay-content a.next").click(function(e)
	{
		e.preventDefault();
		$('.whatsnew-slider').slick('slickNext');
	});
	
	/**
	 * Trigger AOS
	 */
	setTimeout(function () {
		/*$('#loader').fadeOut(500, function () {
			$(this).remove();
		});*/
		AOS.init({
			'offset': -50,
			disable: 'mobile'
		});
	}, 300);

	/**
	 * Fade loading images
	 */
	var load_images_bg = $('body').find('.load-img:not(.loaded), .load-img-uncover:not(.loaded)');
	if (load_images_bg.length) {
		load_images_bg.each(function (index, element) 
		{
			var image = new Image(),
				$element = $(element),
				is_bg_or_img = typeof $element.data('src') !== 'undefined';

			image.onload = function () {
				if (is_bg_or_img) {
					$element.css("backgroundImage", "url('" + $element.attr("data-src") + "')").removeAttr('data-src');
				}
				setTimeout(function () {
					$element.parent().removeClass('loading');
					$element.addClass('loaded');
				}, 200);
			};
			image.src = is_bg_or_img ? $element.attr("data-src") : $element.find('img').attr('src');
		});
	}

	/**
	 * Lazy load images
	 */
	var velcroLazy = {
        /**
         * init
		 * correr on load e sempre que for necessário, por exemplo, a seguir a uma call ajax
		 * elements: passar class dos ementos a fazer lazy load (ex: .lazy)
		 * ex: velcroLazy.init('.lazy');
         */
        init: (elements) => {
            let lazyImages = $(elements);

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function(entries, observer) {
					entries.forEach(function(entry) {
						if (entry.isIntersecting) {
							var lazyImage = $(entry.target),
								image = lazyImage.find('img')[0] || new Image(),
								is_bg_or_img = typeof lazyImage.data('src') !== 'undefined';

							image.onload = function () {
								if (is_bg_or_img) {//is bg
									lazyImage.css("backgroundImage", "url('" + lazyImage.data("src") + "')").removeAttr('data-src');
								}
								setTimeout(function () {
									lazyImage.addClass('loaded').removeClass("lazy").parent().removeClass('loading');
								}, 200);
							};

							image.src = is_bg_or_img ? lazyImage.data("src") : lazyImage.find('img').attr('data-src');
							lazyImageObserver.unobserve(entry.target);
						}
					});
				});

				lazyImages.each(function() {
					lazyImageObserver.observe(this);
				});
			} else {
				lazyImages.each(function() {
					var is_bg_or_img = typeof $(this).data('src') !== 'undefined';
					if (is_bg_or_img) {//is bg
						$(this).css("backgroundImage", "url('" + $(this).data("src") + "')").removeAttr('data-src');
					}else{//is img
						$(this).find('img').attr("src", $(this).find('img').data("src")).removeAttr('data-src');
					}
					$(this).addClass('loaded').removeClass("lazy").parent().removeClass('loading');
				});
			}
        }
	}

	velcroLazy.init('.lazy');

	var root = $('html,body');
	function smoothScrollingTo(target) {

		var target = $(target);
		if (target.length) {
			root.animate({
				scrollTop: target.offset().top - 100
			}, 400, "swing");
		}
	}

	$('a[href*=\\#]:not([href=\\#],[data-toggle],.open-popup)').on('click', function (event) {
		smoothScrollingTo(this.hash);
		if ($('.menu-mobile').hasClass('show')) {
			toogleMenu();
		}
	});

	smoothScrollingTo(location.hash);


	if (!Modernizr.objectfit) {
		$('body .objectfit').each(function () {
			var $container = $(this),
				imgUrl = $container.find('img').prop('src');
			if (imgUrl) {
				$container
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}

	$('.slider-container').slick({
		arrows: false,
		fade: true,
		dots: true,
		draggable: false,
		autoplay: true,
		autoplaySpeed: 5000,
		infinite: true,
		pauseOnHover: false,
		pauseOnDotsHover: true,
		prevArrow: false,
		nextArrow: false,
		responsive: [
		]
	});

	/**
	 * Scroll do menu
	 */
	windowOnScroll();
	$(window).on('scroll', function () {
		windowOnScroll();
	});

	OverlayScrollbars.extension("momentumScroll", function (defaultOptions, framework, compatibility) {
		defaultOptions = defaultOptions || {};
		var osInstance = this;
		var instanceElements = osInstance.getElements();
		var $scroller = framework(instanceElements.viewport);
		var $host = framework(instanceElements.host);
		var isDown = false;
		var startX;
		var scrollLeft;
		var velX = 0;
		var momentumID;

		function handleMousedown(event) {
			isDown = true;
			startX = event.pageX;
			scrollLeft = osInstance.scroll().position.x;
			event.stopPropagation();
			event.preventDefault();
			cancelMomentumTracking();
		}

		function handleMouseleave(event) {
			isDown = false;
		}

		function handleMouseup(event) {
			isDown = false;
			beginMomentumTracking();
			event.preventDefault();
		}

		function handleMouseclick(event) {
			if ($($host).hasClass("os-host-scrolling")) {
				event.preventDefault();
			}
		}

		function handleMousewheel(event) {
			cancelMomentumTracking();
		}

		function handleMousemove(event) {
			if (!isDown) return;
			event.preventDefault();
			const x = event.pageX;
			const walk = (x - startX) * 3;
			var prevScrollLeft = osInstance.scroll().position.x;
			osInstance.scroll({ x: scrollLeft - walk + 'px' });
			velX = osInstance.scroll().position.x - prevScrollLeft;
		}

		function beginMomentumTracking() {
			cancelMomentumTracking();
			momentumID = requestAnimationFrame(momentumLoop);
		}

		function cancelMomentumTracking() {
			cancelAnimationFrame(momentumID);
		}

		function momentumLoop() {
			osInstance.scroll({ x: '+= ' + velX + 'px' });
			velX *= 0.95;
			if (Math.abs(velX) > 0.5) {
				momentumID = requestAnimationFrame(momentumLoop);
			}
		}

		return {
			added(options) {
				options = options || {};

				$scroller.on('mousedown', handleMousedown);
				$scroller.on('mouseleave', handleMouseleave);
				$scroller.on('mouseup', handleMouseup);
				$scroller.on('mousemove', handleMousemove);
				$scroller.find('a').on('click', handleMouseclick);
				$scroller.on('wheel', handleMousewheel);

			}
		};
	});

	$(".velcro-slider").overlayScrollbars({
		overflowBehavior: {
			x: "scroll",
			y: "hidden"
		},
		scrollbars: {
			autoHide: "never",
			dragScrolling: true,
			clickScrolling: true,
			touchSupport: true,
			snapHandle: false
		},
	}, 'momentumScroll').overlayScrollbars();

});

/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
	if (block == 1) {
		$('html').addClass('block-scroll');
	} else if (block == 0) {
		$('html').removeClass('block-scroll');
	}
}

/**
 * Verificar se é um email válido
 */
function IsEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email) ? true : false;
}

/**
 * Verifica se a checkbox de política de privacidade está ou não seleccionada
 */
function checkPolicy(form) {
	var checked = form.find('input[name="checkpolicy[]"]:checked').length;
	if (checked === 1) {
		return true;
	}

	return false;
}

/**
 * Window on scroll
 */
function windowOnScroll() {
	if ($(window).scrollTop() > 45 && $('.site-header').hasClass('big') && $('.site-header').hasClass('should-big')) {
		$('.site-header').removeClass('big');
	} else if ($(window).scrollTop() <= 45 && !$('.site-header').hasClass('big') && $('.site-header').hasClass('should-big')) {
		$('.site-header').addClass('big');
	}
}